import { useLocation, useNavigate } from 'react-router-dom';
import Chart from 'chart.js/auto';
import { useEffect, useRef } from 'react';
import Layout from '../../Common/Layout';
import { StrengthInfocard } from './Infocard/StrengthInfocard';


const StrengthResultPage = (props) => {
    const { state } = useLocation();
    const chartRef = useRef(null);
    const charInstance = useRef(null);
    const navigate = useNavigate();
    console.log(state.StrengthResults)
    useEffect(() => {
        window.scrollTo(0, 0);
        if (charInstance.current) {
            charInstance.current.destroy();
        }

        const myChartRef = chartRef.current.getContext('2d');



        var colors = ['rgba(143, 49, 58, 0.90)', 'rgba(106, 136, 255, 0.90)', 'rgba(0, 125, 89, 0.90)', 'rgba(247, 203, 66, 0.90)', 'rgba(128, 0, 128, 0.90)', 'rgba(70, 130, 180, 0.90)', 'rgba(143, 49, 58, 0.90)', 'rgba(106, 136, 255, 0.90)', 'rgba(0, 125, 89, 0.90)', 'rgba(247, 203, 66, 0.90)']

        charInstance.current = new Chart(myChartRef, {
            type: 'bar',
            data: {
                labels: Object.keys(state.StrengthResults),
                datasets: [
                    {
                        label: "Strengths",
                        data: Object.values(state.StrengthResults),
                        backgroundColor: colors
                    },
                ],
            },
            options: {
                plugins: {
                    legend: {
                        display: false
                    },
                },
                scales: {
                    x: {
                        display: true,
                        ticks: {
                            color: 'black',
                        },
                    },
                    y: {
                        display: true,
                        ticks: {
                            color: 'black',
                        },
                    },
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
            },
        });

        return () => {
            if (charInstance.current) {
                charInstance.current.destroy();
            }
        };
    }, []);

    function bookAppointment() {
        navigate('/booking');
    }

    return (
        <Layout>
            <div className='resultsContainer'>
                <h1 className='resultsHeading'>Your results are ready!🎉</h1>
                <div className='resultsText'>
                    Based on the questions you answered, here is the breakdown of your unique strengths.
                </div>
                <div className="chartContainer">
                    <div>
                        <canvas id="myChart" ref={chartRef} className='ResultsBarGraph'></canvas>
                    </div>
                </div>
                <StrengthInfocard />
            </div>

            <div className='bookingContainer'>
                <div className='counsellingHeading'>
                    Still confused? </div>
                <div className='counsellingText'>Book a counseling session for one-on-one personal guidance!
                </div>
                <button className='bookAppointment' onClick={() => bookAppointment()}>Book Appointment</button>
            </div>
        </Layout>
    );
};

export default StrengthResultPage